import { STATUSZ } from './Const';
import notify from '../mixins/Notify';
import EventBus from './EventBus';
import { notifyAllReponseErrors, scrollToElementByIdWithOffset } from './SaveErrorHandler';

export default class TarifaManager {
    constructor(store, router, validator, pages, saveUrls) {
        this.store = store;
        this.router = router;
        this.validator = validator;
        this.pages = pages;
        this.saveUrls = saveUrls;
        this.saveInProgress = false;
        this.clientValidation = false;

        EventBus.$on('abort', () => {
            this.saveInProgress = false;
        });
    }

    getInitData() {
        try {
            const initDataElement = document.getElementById('init-data');
            if (initDataElement) {
                const ceg = initDataElement.getAttribute('data-ceg');
                const felhasznalo = initDataElement.getAttribute('data-felhasznalo');
                this.store.commit('setFelhasznalo', felhasznalo);
                this.store.commit('setCeg', ceg);
                this.store.commit('setLoginCeg', ceg);
            }
        } catch (e) {
            throw new Error(e);
        }
    }

    testInit() {
        return new Promise(() => {
            this.getInitData();
            this.store.commit('setCurrentPage', 0);
            this.store.commit('stopLoading');
        });
    }

    async init(page, routeParams, queryParams = {}, cb = null) {
        this.getInitData();
        this.validator.clear();
        this.store.commit('setCurrentPage', page);
        this.onNext = cb;

        await this.store.dispatch('getBroker');
        await this.store.dispatch('getCompanyDeclarations');

        return new Promise((resolve, reject) => {
            if ((
                (
                    routeParams.id != null && routeParams.id !== '-1'
                )
                && (
                    routeParams.tid != null && routeParams.tid !== '-1'
                )) || queryParams?.token
            ) {
                this.store.commit('init', {
                    id: routeParams.id,
                    tid: routeParams.tid,
                    token: queryParams?.token,
                });
                this.store.dispatch('loadTarifa', page).then((response) => {
                    this.store.commit('setCurrentPage', page);
                    resolve(response);
                }, (error) => {
                    reject(error);
                });
            } else {
                this.store.commit('setCurrentPage', page);
                this.store.commit('stopLoading');
                resolve();
            }
        });
    }

    back() {
        this.store.dispatch('back');
        this.toCurrentPage();
    }

    save() {
        if (this.store.getters.statusz < STATUSZ.AJANLAT) {
            return this.saveApi(true).then(() => {
                notify.successNotify();
            });
        }
        return Promise.reject();
    }

    validNext() {
        if (this.onNext == null) {
            this.onNext = () => {
            };
        }
        this.validator.getOnNextCbs().forEach((cbfunc) => {
            cbfunc();
        });
        if (this.validator.isValid()) {
            if (this.saveInProgress) return;
            this.saveInProgress = true;
            this.saveApi(false).then(() => {
                notify.successNotify();
                this.store.commit('setNextPageAvailable', true);
                this.toCurrentPage();
                this.saveInProgress = false;
            }).catch((error) => {
                notifyAllReponseErrors(error.response.data);
                this.saveInProgress = false;
            }).finally(() => {
                this.saveInProgress = false;
            });
        } else {
            const errors = this.validator.getErrors();
            scrollToElementByIdWithOffset(errors[0].location.split('#').join(''), 200);
            errors.reverse();
            errors.forEach((error) => {
                notify.failureNotify(error.title, error.message);
            });
        }
        // ez nem tudom, hogy miért volt itt és hogy kell-e ide de konstans true
        // if (this.store.getters.statusz < STATUSZ.AJANLAT || true) {
        //     if (this.validator.isValid()) {
        //         if (this.saveInProgress) return;
        //         this.saveInProgress = true;
        //         this.saveApi(false).then((response) => {
        //             notify.successNotify();
        //             this.store.commit('setNextPageAvailable', true);
        //             this.toCurrentPage();
        //             this.saveInProgress = false;
        //         }).catch((error) => {
        //             notifyAllReponseErrors(error.response.data);
        //             this.saveInProgress = false;
        //         }).finally(() => {
        //             this.saveInProgress = false;
        //         });
        //     } else {
        //         const errors = this.validator.getErrors();
        //         scrollToElementById(errors[0].location.split('#').join(''));
        //         errors.reverse();
        //         errors.forEach((error) => {
        //             notify.failureNotify(error.title, error.message);
        //         });
        //     }
        // } else {
        //     this.store.dispatch('next');
        //     this.toCurrentPage();
        // }
    }

    getHighestElement(errors) {
        let highestId = errors[0];
        let distance = this.constructor.getDistanceFromTop(highestId);

        for (let i = 1; i < errors.length; i += 1) {
            const nextElement = errors[i];
            const nextDistance = this.constructor.getDistanceFromTop(nextElement);
            if (nextDistance < distance) {
                highestId = nextElement;
                distance = nextDistance;
            }
        }
        return highestId;
    }

    static getDistanceFromTop(id) {
        if (document.getElementById(id)) {
            return document.getElementById(id).getBoundingClientRect().top;
        }
        return 0;
    }

    async next() {
        if (this.onNext) await this.onNext();

        if (this.clientValidation) {
            this.validNext();
        } else {
            if (this.saveInProgress) return;
            this.saveInProgress = true;
            this.saveApi(false).then(() => {
                this.store.commit('setErrors', []);
                notify.successNotify();
                this.store.commit('setNextPageAvailable', true);
                this.toCurrentPage();
                this.saveInProgress = false;
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    this.store.commit('setErrors', error.response.data);
                    // TODO:: az error szövege lehetne az egyik error hogy tudja mit keressen
                    notify.failureNotify(
                        error.response.data[Object.keys(error.response.data)[0]],
                        'Hibás mező',
                    );

                    const firstErrorId = this.getHighestElement(Object.keys(error.response.data));
                    scrollToElementByIdWithOffset(firstErrorId, 200);
                }
                this.saveInProgress = false;
            }).finally(() => {
                this.saveInProgress = false;
            });
        }
    }

    getSaveUrl() {
        return this.saveUrls[this.store.getters.currentPage].split('/').join('');
    }

    getCurrentPageUrl() {
        return `${this.pages[this.store.getters.currentPage].split('/:')[0]}/${this.store.getters.id}`
            + `/${this.store.getters.tid}`;
    }

    saveApi(plainSave = false) {
        return this.store.dispatch(this.getSaveUrl(), { plainSave });
    }

    toCurrentPage() {
        this.router.push({
            path: this.getCurrentPageUrl(),
        });
    }

    setSaveUrl(page, url) {
        this.saveUrls[page] = url;
    }

    setClientValidation(validate) {
        this.clientValidation = validate;
    }
}
